class MobileFilters {
  constructor() {
    this.mobileFilters = document.querySelector('.mobile-filters');
    this.mainFilterForm = document.querySelector('form#CollectionFilterForm');
    this.desktopFilters = document.querySelector('.filters');
    if (!this.mobileFilters || !this.mainFilterForm || !this.desktopFilters) return;

    this.activeFilterGroup = null;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupTouchScrolling();
    this.syncInitialState();
  }

  showFilterGroup(groupName) {
    const groupButtons = this.mobileFilters.querySelectorAll('.mobile-filter-group-button');
    const filterGroups = this.mobileFilters.querySelectorAll('.mobile-filter-group');

    if (this.activeFilterGroup && this.activeFilterGroup !== groupName) {
      this.clearFilterGroup(this.activeFilterGroup);
    }

    groupButtons.forEach(button => {
      button.classList.toggle('mobile-filter-group-button--active', button.dataset.filterGroup === groupName);
    });

    filterGroups.forEach(group => {
      group.classList.toggle('mobile-filter-group--active', group.dataset.filterGroup === groupName);
    });

    this.autoSelectGroupIfEmpty(groupName);
    this.activeFilterGroup = groupName;
  }

  clearFilterGroup(groupName) {
    const group = this.mobileFilters.querySelector(`.mobile-filter-group[data-filter-group="${groupName}"]`);
    if (!group) return;

    const inputs = group.querySelectorAll('input[type="checkbox"]:checked');
    inputs.forEach(input => {
      input.checked = false;
      this.updateButtonState(input);

      if (this.desktopFilters) {
        const desktopInput = this.desktopFilters.querySelector(`input[name="${input.name}"][value="${input.value}"]`);
        if (desktopInput) {
          desktopInput.checked = false;
          desktopInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    const button = this.mobileFilters.querySelector(`.mobile-filter-group-button[data-filter-group="${groupName}"]`);
    if (button) {
      button.classList.remove('mobile-filter-group-button--active');
      const indicator = button.querySelector('.mobile-filter-group-button__indicator');
      if (indicator) indicator.remove();
    }
  }

  autoSelectGroupIfEmpty(groupName) {
    const filterGroup = this.mobileFilters.querySelector(`.mobile-filter-group[data-filter-group="${groupName}"]`);
    if (!filterGroup) return;

    const checkedInputs = filterGroup.querySelectorAll('input[type="checkbox"]:checked');
    if (checkedInputs.length === 0) {
      const allInputs = filterGroup.querySelectorAll('input[type="checkbox"]');
      allInputs.forEach(input => {
        input.checked = true;
        this.updateButtonState(input);

        if (this.desktopFilters) {
          const desktopInput = this.desktopFilters.querySelector(`input[name="${input.name}"][value="${input.value}"]`);
          if (desktopInput) {
            desktopInput.checked = true;
            desktopInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      this.updateGroupButtonStates();
    }
  }

  syncInitialState() {
    const desktopInputs = this.desktopFilters.querySelectorAll('input[type="checkbox"]');
    desktopInputs.forEach(input => {
      const mobileInput = this.mobileFilters.querySelector(`input[name="${input.name}"][value="${input.value}"]`);
      if (mobileInput) {
        mobileInput.checked = input.checked;
        this.updateButtonState(mobileInput);
      }
    });

    this.updateGroupButtonStates();
  }

  updateGroupButtonStates() {
    const groupButtons = this.mobileFilters.querySelectorAll('.mobile-filter-group-button');
    groupButtons.forEach(button => {
      const groupName = button.dataset.filterGroup;
      const filterGroup = this.mobileFilters.querySelector(`.mobile-filter-group[data-filter-group="${groupName}"]`);
      if (filterGroup) {
        const hasActive = filterGroup.querySelectorAll('input[type="checkbox"]:checked').length > 0;
        button.classList.toggle('mobile-filter-group-button--active', hasActive);
        let indicator = button.querySelector('.mobile-filter-group-button__indicator');
        if (hasActive && !indicator) {
          indicator = document.createElement('span');
          indicator.className = 'mobile-filter-group-button__indicator';
          button.appendChild(indicator);
        } else if (!hasActive && indicator) {
          indicator.remove();
        }
      }
    });
  }

  updateButtonState(input) {
    const button = input.closest('.mobile-filter-button');
    if (button) {
      button.classList.toggle('mobile-filter-button--active', input.checked);
    }
    this.updateGroupButtonStates();
  }

  setupEventListeners() {
    const groupButtons = this.mobileFilters.querySelectorAll('.mobile-filter-group-button');
    groupButtons.forEach(button => {
      button.addEventListener('click', () => {
        const groupName = button.dataset.filterGroup;
        this.showFilterGroup(groupName);
      });
    });

    this.mobileFilters.addEventListener('change', (e) => {
      if (e.target.classList.contains('mobile-filter-button__input')) {
        const input = e.target;

        const group = input.closest('.mobile-filter-group');
        if (group) {
          // Limpiar todos los filtros del grupo
          const checkboxes = group.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach(checkbox => {
            checkbox.checked = false;
            this.updateButtonState(checkbox);

            const desktopInput = this.desktopFilters.querySelector(`input[name="${checkbox.name}"][value="${checkbox.value}"]`);
            if (desktopInput) {
              desktopInput.checked = false;
              desktopInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });

          // Activar solo el clickeado
          input.checked = true;
          this.updateButtonState(input);

          const desktopInput = this.desktopFilters.querySelector(`input[name="${input.name}"][value="${input.value}"]`);
          if (desktopInput) {
            desktopInput.checked = true;
            desktopInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          this.updateGroupButtonStates();
        }
      }
    });

    if (this.desktopFilters) {
      this.desktopFilters.addEventListener('change', (e) => {
        if (e.target.type === 'checkbox') {
          const input = e.target;
          const mobileInput = this.mobileFilters.querySelector(`input[name="${input.name}"][value="${input.value}"]`);
          if (mobileInput) {
            mobileInput.checked = input.checked;
            this.updateButtonState(mobileInput);
          }
        }
      });
    }

    const allButtons = this.mobileFilters.querySelectorAll('.mobile-filter-button, .mobile-filter-group-button');
    allButtons.forEach(button => {
      button.addEventListener('touchstart', () => button.style.transform = 'scale(0.95)', { passive: true });
      button.addEventListener('touchend', () => button.style.transform = '', { passive: true });
    });
  }

  setupTouchScrolling() {
    const sliders = this.mobileFilters.querySelectorAll('.mobile-filter-group, .mobile-filters__groups');
    sliders.forEach(slider => {
      let isScrolling = false, startX, scrollLeft;
      slider.addEventListener('touchstart', (e) => {
        isScrolling = true;
        startX = e.touches[0].pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      }, { passive: true });

      slider.addEventListener('touchmove', (e) => {
        if (!isScrolling) return;
        const x = e.touches[0].pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
      }, { passive: true });

      slider.addEventListener('touchend', () => {
        isScrolling = false;
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MobileFilters();
});
